
module.exports = {
    addBtn: 'btn btn-xs btn-default',
    iconAdd: "icon-add"
};


/** WEBPACK FOOTER **
 ** ./~/subschema/src/styles/CollectionMixin-style.js
 **/